var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.47422 4.975L0.849219 1.35C0.799219 1.3 0.761886 1.246 0.737219 1.188C0.712552 1.13 0.699885 1.06733 0.699219 1C0.699219 0.866667 0.745219 0.75 0.837219 0.65C0.929219 0.55 1.04989 0.5 1.19922 0.5H8.79922C8.94922 0.5 9.07022 0.55 9.16222 0.65C9.25422 0.75 9.29988 0.866667 9.29922 1C9.29922 1.03333 9.24922 1.15 9.14922 1.35L5.52422 4.975C5.44089 5.05833 5.35755 5.11667 5.27422 5.15C5.19089 5.18333 5.09922 5.2 4.99922 5.2C4.89922 5.2 4.80755 5.18333 4.72422 5.15C4.64089 5.11667 4.55755 5.05833 4.47422 4.975Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow);
export default __webpack_public_path__ + "static/media/icon-arrow.44c991f4ad843dbfe7468c3c4c220b68.svg";
export { ForwardRef as ReactComponent };